import {Stack, Typography, Divider} from "@mui/material";
import AdmsIdentifierDisplay from "./AdmsIdentifierDisplay";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function DocumentationItemDisplay(props) {
  // const [mappings, setMappings] = useState(props.mappings);
  const [documentationList, setDocumentationList] = useState(props.documentationList);
  const {defaultLanguage, mappings, topLabel} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }
  if (!documentationList || documentationList.length === 0) return null;

  return (
    <Stack sx={{pt: 1, pb: 2}} spacing={1}>
      <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>{topLabel}</Typography>
      {documentationList.map((item, index) => {
        const isLastElement = index === documentationList.length - 1;
        return (
          <div key={index}>
            {item.citationText && !isEmpty(item.citationText.getValue(defaultLanguage)) && (
              <div>
                <Typography variant="body2" className={"key"}>{getLabel(keys.citationText, "citationText")}</Typography>
                <Typography variant="body1">{item.citationText.getValue(defaultLanguage)}</Typography>
              </div>
            )}
            {item.title && !isEmpty(item.title.getValue(defaultLanguage)) && (
              <div>
                <Typography variant="body2" className={"key"}>{getLabel(keys.title, "title")}</Typography>
                <Typography variant="body1">{item.title.getValue(defaultLanguage)}</Typography>
              </div>
            )}
            <Stack sx={{pt: 1}} spacing={1}>
              <AdmsIdentifierDisplay defaultLanguage={defaultLanguage} mappings={mappings} admsIdentifierList={item.admsList} />
            </Stack>
            <Divider component="div" role="presentation" className={`dashed ${isLastElement ? "hide-divider" : ""}`} />
          </div>
        );
      })}
    </Stack>
  );
}
